import React from 'react';

import JackpotCard from "@common/components/jackpot/card";

const Jackpot = ({ openPopup, closePopup, theme, mode, id, config }) => (
  <JackpotCard openPopup={openPopup} closePopup={closePopup} theme={theme} mode={mode} betshopId={id} config={config} />
);


export default Jackpot;
